import request from '@/utils/request';
//活动分页
export function getQuerySendLog(values) {
  return request('/activityStaff/querySendLog', {
    method: 'POST',
    data: values,
  });
}
